import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { classIf } from '../../data/utils/classIf';
import { PrematchContext } from '../Prematch';

function MenuTournamentItem(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    //const absoluteTournamentPath = useAbsolutePath(props.href,null,props.urlPathSeo,false);
    const relativeTournamentPath = useAbsolutePath(props.href,null,props.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);

    function handleClickHref(url,e){
        e.preventDefault();
        props.action();
    }

    function toggleFavorite(e) {
        e.stopPropagation();
        e.preventDefault();
        prematchContext.toggleFavoriteTournament(tournamentUniqueId);
    }

    function handleOnClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            if(props.action){
                props.action();
            }
        }else{
            appContext.setHandleOpenFromPath(true);
        }
        //props.action();
    }

    const tournamentUniqueId = `${props.sportRef}_${props.categoryRef}_${props.id}`;

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
       /*  <a href={encodeURI(absoluteTournamentPath)} className="list-element striped" onClick={handleClickHref.bind(this,absoluteTournamentPath)}> */
        <Link to={encodeURI(relativeTournamentPath) } className="list-element striped" onClick={handleOnClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
            <div className={"prematch-sport-img big"}></div>
            <span className="list-element-text">{props.desc}</span>
            <div className="d-flex push-right mr-2">
                {props.isLive &&
                    <div className="badge-live mr-2"></div>
                }
                <span className="list-element-info">{props.info}</span>
                <div className="pin-toggle" onClick={toggleFavorite}>
                    <i className={"fas fa-thumbtack rotate-45" + classIf(prematchContext.favoriteTournaments[tournamentUniqueId] === true, 'selected')}></i>
                </div>
            </div>
            <span className="arrow arrow-right"></span>
        </Link>
        /* </a> */
    );
}

export default MenuTournamentItem;